import React from 'react';
import {
  Input,
  InputProps,
} from '@ast/magma/components/input';

export const ACCOUNT_NUMBER_LENGTH = 17;
export const ACCOUNT_NUMBER_LENGTH_IBAN = 34;
export const ACCOUNT_NUMBER_PATTERN = /^[0-9a-z]+$/i;

export type AccountNumberFieldProps = InputProps
& React.InputHTMLAttributes<HTMLInputElement>
& React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export type AccountNumberFieldRef = HTMLInputElement & HTMLTextAreaElement;

export const AccountNumberField = React.forwardRef((
  props: AccountNumberFieldProps,
  ref: React.Ref<AccountNumberFieldRef>,
) => (
  <Input
    autoComplete="off"
    type="text"
    {...props}
    ref={ref}
  />
));
